exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__logo___iDRhQ{align-self:baseline;display:flex;align-items:center;justify-content:center;height:90px;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;max-width:200px;background-color:#fff;padding:10px 20px;border-radius:0 0 20px 20px;box-shadow:0 2px 3px 0 rgba(0,0,0,.12)}.index-module__logo___iDRhQ .index-module__wrapper___XfxmV{display:block;max-width:125px}.index-module__logo___iDRhQ .index-module__wrapper___XfxmV img{width:300px}@media (min-width:1325px){.index-module__logo___iDRhQ .index-module__wrapper___XfxmV{max-width:170px}}", ""]);

// exports
exports.locals = {
	"logo": "index-module__logo___iDRhQ",
	"wrapper": "index-module__wrapper___XfxmV"
};